module.exports = __webpack_public_path__ + "static/media/paiming2.72897006.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/activity_130/image/paiming2.png
// module id = 381
// module chunks = 0